import React from 'react'
import PropTypes from 'prop-types'
import { graphql, Link } from 'gatsby'
import _get from 'lodash/get'
import _isEmpty from 'lodash/isEmpty'

import { datoFpDebug } from '../../../config/site'

import ArrowRightSVG from '../../assets/svg/arrow-right.svg'

const FP_DEBUG = datoFpDebug

const ArticleLink = ({ article }) => {
  const image = article.thumbnail
  let src = `${image.url}?&fp-debug=${FP_DEBUG}&crop=focalpoint&fit=crop&fp-x=0.5&fp-y=0.5`

  return (
    <div className="c-articleOfInterest mb-3" data-datocms-noindex>
      <p className="c-articleOfInterest__header c-articleOfInterest__header--sm">
        You may also be interested in…
      </p>
      <div className="c-articleOfInterestThumbnail c-articleOfInterestThumbnail--lg">
        <img
          className="img-fluid"
          src={`${src}&w=260&h=300`}
          title={image.title}
          alt={image.alt}
          loading="lazy"
        />
      </div>
      <div className="c-articleOfInterestThumbnail c-articleOfInterestThumbnail--sm">
        <picture loading="lazy">
          <source
            srcSet={`${src}&w=350&h=320&dpr=1 1x, ${src}&w=350&h=320&dpr=2 2x, ${src}&w=350&h=320&dpr=3 3x`}
            media="(min-width: 768px)"
          />
          <source
            srcSet={`${src}&w=450&h=350&dpr=1 1x`}
            media="(min-width: 400px)"
          />
          <img
            className="img-fluid"
            srcSet={`${src}&w=350&h=320&dpr=1 1x, ${src}&w=350&h=320&dpr=2 2x, ${src}&w=350&h=320&dpr=3 3x`}
            src={`${src}&w=350&h=220`}
            title={image.title}
            alt={image.alt}
            loading="lazy"
          />
        </picture>
      </div>
      <div className="c-articleOfInterestBody">
        <p className="c-articleOfInterest__header c-articleOfInterest__header--lg">
          You may also be interested in…
        </p>
        <div className="c-articleOfInterest__cta">
          <h4 className="c-articleOfInterest__cta__title">{article.title}</h4>
          <Link
            to={article.relPath}
            className="c-button c-button--secondary"
            title={'Read ' + article.title}
          >
            <ArrowRightSVG className="c-icon mr-2" />
            Read
          </Link>
        </div>
      </div>
    </div>
  )
}

ArticleLink.propTypes = {
  article: PropTypes.object.isRequired,
}

export default ArticleLink

export const FragmentQuery = graphql`
  fragment NewsArticleLinkFragment on DatoCmsNewsArticle {
    id
    title
    category
    categoryLink
    relPath
    thumbnail: thumbnailImage {
      title
      alt
      url
    }
  }
  fragment EditorialArticleLinkFragment on DatoCmsEditorialArticle {
    id
    title
    category
    categoryLink
    relPath
    thumbnail: heroImage {
      title
      alt
      url
    }
  }
  fragment DatapolArticleLinkFragment on DatoCmsDatapool {
    id
    title
    category
    categoryLink
    relPath
    thumbnail: thumbnailImage {
      title
      alt
      url
    }
  }
  fragment RecipeArticleLinkFragment on DatoCmsRecipe {
    id
    title
    category
    categoryLink
    relPath
    thumbnail: heroImage {
      title
      alt
      url
    }
  }
`
